<template>
  <Navbar pageName="tmc" />
  <template v-if="isMobile">
    <MobileBanner :bannerList="mobileBannerList" />
    <MobileProduct />
    <MobileSuccessCase />
    <MobileComment />
    <MobileAffirm />
    <MobileFooter />
  </template>
  <template v-else>
    <DesktopBanner :bannerList="pcBannerList" />
    <DesktopProduct />
    <DesktopProgramme />
    <DesktopWhyUs />
    <DesktopSuccessCase />
    <DesktopComment />
    <DesktopAffirm />
    <Feature />
    <DesktopFooter />
  </template>
</template>

<script>
import DesktopBanner from '@/shared/components/banner/desktop-banner'
import DesktopFooter from '@/shared/components/footer/desktop-footer.vue'
import Feature from '@/shared/components/feature.vue'
import MobileBanner from '@/shared/components/banner/mobile-banner.vue'
import MobileFooter from '@/shared/components/footer/mobile-footer.vue'
import Navbar from '@/shared/components/navbar.vue'

import DesktopAffirm from './components/affirm/desktop-affirm.vue'
import DesktopComment from './components/comment/desktop-comment.vue'
import DesktopProduct from './components/product/desktop-product.vue'
import DesktopProgramme from './components/programme/desktop-programme.vue'
import DesktopSuccessCase from './components/success-case/desktop-success-case.vue'
import DesktopWhyUs from './components/why-us/desktop-why-us.vue'
import MobileAffirm from './components/affirm/mobile-affirm.vue'
import MobileComment from './components/comment/mobile-comment.vue'
import MobileProduct from './components/product/mobile-product.vue'
import MobileSuccessCase from './components/success-case/mobile-success-case.vue'

import { isMobile } from '@/shared/utils/equipment.utils.js'

export default {
  components: {
    DesktopAffirm,
    DesktopBanner,
    DesktopComment,
    DesktopFooter,
    DesktopProduct,
    DesktopProgramme,
    DesktopSuccessCase,
    DesktopWhyUs,
    Feature,
    MobileAffirm,
    MobileBanner,
    MobileComment,
    MobileFooter,
    MobileProduct,
    MobileSuccessCase,
    Navbar,
  },
  setup() {
    const pcBannerList = [
      './images/gp-banner1.png',
      './images/gp-banner2.png',
      './images/gp-banner3.png',
      './images/index-banner3.png',
    ]
    const mobileBannerList = [
      './images/mobile/gp-banner1.png',
      './images/mobile/gp-banner2.png',
      './images/mobile/gp-banner3.png',
      './images/mobile/index-banner3.png',
    ]

    return { pcBannerList, mobileBannerList, isMobile: isMobile() }
  },
}
</script>
